/**
 * Transfers from an account that is not the client's registered one (S-27): the compliance
 * cases. Visible only to the designated compliance officer and super_admins; the server answers
 * 403 to everyone else.
 */
import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export interface TransferCase {
  id: string;
  bank_transaction_id: string;
  client_id: string;
  reason: 'sender_not_registered' | 'source_account_refused';
  sanctions_outcome: 'clear' | 'potential_match' | 'not_screened';
  opened_at: string;
  status: 'open' | 'closed';
  closed_reason: string | null;
  aviso_decision: 'not_assessed' | 'filed' | 'not_filed';
  aviso_note: string | null;
  amount: string;
  currency_code: string;
  sender_name: string | null;
  hours_open: number;
}

export type AvisoDecision = 'filed' | 'not_filed';

class TransferCasesService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async list(): Promise<TransferCase[]> {
    const res = await this.api.get<TransferCase[]>('/api/v1/compliance/transfer-cases');
    return res.data;
  }

  async decideAviso(
    caseId: string,
    decision: AvisoDecision,
    note: string,
    mfaCode: string,
  ): Promise<void> {
    await this.api.post(`/api/v1/compliance/transfer-cases/${caseId}/aviso`, {
      decision,
      note,
      mfa_code: mfaCode,
    });
  }
}

export default new TransferCasesService();
